import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Toasted from 'vue-toasted'
import VModal from 'vue-js-modal/dist/ssr.nocss'

import 'vue-js-modal/dist/styles.css'
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

loadProgressBar()
Vue.use(VModal, { componentName: 'Modal' })
Vue.use(Toasted)
const error_options = {
    type: 'error',
    position: 'bottom-center',
    singleton: true,
    theme: 'bubble',
    duration: 5000,
    onClick: (e, toastObject) => {
        toastObject.goAway(0)
    }
}
const success_options = {
    type: 'success',
    singleton: true,
    position: 'bottom-center',
    duration: 5000,
    onClick: (e, toastObject) => {
        toastObject.goAway(0)
    }
}
Vue.toasted.register('error',
    (payload) => {
        // if there is no message passed show default message
        if (!payload.message) {
            return 'Oops.. Something Went Wrong..'
        }
        // if there is a message show it with the message
        return payload.message
    },
    error_options
)
Vue.toasted.register('success',
    (payload) => {
        // if there is no message passed show default message
        if (!payload.message) {
            return 'Greate.. Proceed Successfully..'
        }
        // if there is a message show it with the message
        return payload.message
    },
    success_options
)
Vue.use(VueSweetalert2)
Vue.component("MssInput", require("@/components/MssInput").default);
Vue.component('MssImage', require("@/components/MssImage").default);
Vue.component("MssSelect", require("vue-select").default);
import "vue-select/dist/vue-select.css";
Vue.config.productionTip = false
new Vue({
    data: {
        URL_ROOT: 'https://api.shapenprint.com/',
        TELYPORT_ROOT: 'https://shipping.shapenprint.com/telyport',
        SHIPROCKET_ROOT: 'https://shipping.shapenprint.com/shiprocket',
        SHIPROCKET_EMAIL: 'support@jurysoft.com',
        SHIPROCKET_PASSWORD: 'lyQmeH*n&V6&1PFssaQWj8YEqZJA!dyQ',
        INVOIC: 'https://calibreply.com/',
        auth: { Authorization: localStorage.getItem('token') }
    },
    store,
    router,
    render: h => h(App)
}).$mount('#app')